export default __webpack_public_path__ + "static/media/me.a4df40db.png";